import { render, staticRenderFns } from "./TheLoginForm.vue?vue&type=template&id=0c0fcab0&scoped=true&"
import script from "./TheLoginForm.vue?vue&type=script&lang=js&"
export * from "./TheLoginForm.vue?vue&type=script&lang=js&"
import style0 from "./TheLoginForm.vue?vue&type=style&index=0&id=0c0fcab0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0fcab0",
  null
  
)

export default component.exports